"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var preact_1 = require("preact");
var FilePicker = /** @class */ (function (_super) {
    __extends(FilePicker, _super);
    function FilePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pickerRef = (0, preact_1.createRef)();
        _this.handleFileChange = function (_a) {
            var _b;
            var currentTarget = _a.currentTarget;
            var files = (_b = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.files) !== null && _b !== void 0 ? _b : [];
            var selectedFile = files[0];
            if (_this.props.onChange && selectedFile) {
                _this.props.onChange(selectedFile);
                setTimeout(function () {
                    if (_this.pickerRef.current) {
                        _this.pickerRef.current.value = '';
                    }
                }, 500);
            }
        };
        _this.openFilePicker = function () {
            if (_this.pickerRef.current) {
                _this.pickerRef.current.click();
            }
        };
        return _this;
    }
    FilePicker.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)("input", { onChange: this.handleFileChange, ref: this.pickerRef, disabled: !!this.props.loading, class: "w-0 h-0 hidden", type: "file", accept: "image/*" });
    };
    return FilePicker;
}(preact_1.Component));
exports.default = FilePicker;
